/* SurveyMarshal.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./SurveyMarshal.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Transition } from 'react-transition-group';
import { layers } from '@atlaskit/theme/constants';
import { surveyInnerWidth, surveyOffset } from '../constants';
var animationDuration = 300;
var offscreen = {
  translateX: "".concat(surveyInnerWidth + surveyOffset, "px"),
  opacity: '0'
};
var getAnimationProps = function getAnimationProps(state) {
  switch (state) {
    case 'entered':
      {
        return {
          translateX: '0',
          opacity: '1'
        };
      }
    case 'entering':
    case 'unmounted':
    case 'exited':
    case 'exiting':
      {
        return offscreen;
      }
  }
};
var transitionBaseStyles = null;
export default function SurveyMarshal(props) {
  var children = props.children,
    shouldShow = props.shouldShow;
  return /*#__PURE__*/React.createElement(Transition, {
    in: shouldShow,
    timeout: animationDuration,
    unmountOnExit: true
  }, function (state) {
    var _getAnimationProps = getAnimationProps(state),
      translateX = _getAnimationProps.translateX,
      opacity = _getAnimationProps.opacity;
    return /*#__PURE__*/React.createElement("div", {
      className: ax(["_kqsw1n9t _1xi28err _94n58err _k8m01rjc"]),
      style: {
        opacity: opacity,
        transition: "all ".concat(animationDuration, "ms ease-in-out"),
        zIndex: layers.flag(),
        transform: "translateX(".concat(translateX, ")"),
        "--_1hx5ohh": ix("".concat(surveyOffset, "px"))
      }
    }, children());
  });
}